import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-mb-0" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Modifca ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-formgroup" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_5 = { class: "p-grid" }
const _hoisted_6 = { class: "p-col-6 p-grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", { class: "p-col" }, "Totale minuti:", -1)
const _hoisted_8 = { class: "p-grid" }
const _hoisted_9 = { class: "p-col-6 p-grid" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", { class: "p-col" }, "Note:", -1)
const _hoisted_11 = {
  key: 0,
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _directive_date_format = _resolveDirective("date-format")!

  return (_openBlock(), _createBlock(_component_PDialog, {
    style: { width: '450px' },
    modal: true,
    class: "p-fluid",
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.badge.badge_date), 1)
        ], 512), [
          [_directive_date_format]
        ])
      ]),
      _createVNode(_component_Toast, { group: "this_dialog" })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Annulla",
        icon: "pi pi-times",
        class: "p-button-secondary",
        onClick: _ctx.onCancel
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Conferma",
        icon: "pi pi-check",
        disabled: !_ctx.badge.note_edit,
        loading: _ctx.isLoading,
        onClick: _ctx.onConfirm
      }, null, 8, ["disabled", "loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _hoisted_3,
        _createVNode(_component_Card, { class: "p-mt-3 p-shadow-2" }, {
          title: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.badge.entity?.business_name), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.badge.total_minutes_worked,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.badge.total_minutes_worked = $event))
                }, null, 8, ["modelValue"]),
                _createTextVNode(_toDisplayString(_ctx.getFormatMinutesHour()), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", null, _toDisplayString(_ctx.badge.note_user), 1),
                _createVNode(_component_InputText, {
                  modelValue: _ctx.badge.note_edit,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.badge.note_edit = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            (_ctx.showWaring())
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "ATTENZIONE: stai modificando una timbratura di oggi. Nuove timbrature nella giornata odierna potrebbero sovrascrivere questi valori"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}